import { motion } from 'framer-motion';
import { useClinicConfigContext } from '@/contexts/ClinicConfigContext';

// Animation variants
const staggerContainer = {
  animate: {
    transition: {
      staggerChildren: 0.1,
    },
  },
};

const fadeInUp = {
  initial: { opacity: 0, y: 30 },
  animate: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: 'easeOut' },
  },
};

interface FooterProps {
  /** Animation delay for the footer appearance */
  animationDelay?: number;
  /** Animation duration */
  animationDuration?: number;
  /** Whether to use motion animations */
  useMotion?: boolean;
  /** Custom className for the footer container */
  className?: string;
  /** Whether to show the footer in a column layout on mobile */
  mobileColumnLayout?: boolean;
}

export function Footer({
  animationDelay = 1.3,
  animationDuration = 0.6,
  useMotion = true,
  className = '',
  mobileColumnLayout = false,
}: FooterProps) {
  const { clinic } = useClinicConfigContext();

  const footerContent = (
    <div className={`flex-shrink-0 lg:p-6 p-4 ${className}`}>
      <div
        className={`flex ${
          mobileColumnLayout ? 'flex-col lg:flex-row' : 'flex-row'
        } justify-between items-center text-sm text-gray-500`}
      >
        <span>© 2025 {clinic?.name || 'Clinic'}</span>
        <span>{clinic?.address || ''}</span>
      </div>
    </div>
  );

  if (!useMotion) {
    return footerContent;
  }

  return (
    <motion.div
      className={`flex-shrink-0 lg:p-6 p-4 ${className}`}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: animationDelay, duration: animationDuration }}
    >
      <motion.div
        className={`flex ${
          mobileColumnLayout ? 'flex-col lg:flex-row' : 'flex-row'
        } justify-between items-center text-sm text-gray-500`}
        variants={staggerContainer}
        initial='initial'
        animate='animate'
      >
        <motion.span variants={fadeInUp}>
          © 2025 {clinic?.name || 'Clinic'}
        </motion.span>
        <motion.span variants={fadeInUp}>{clinic?.address || ''}</motion.span>
      </motion.div>
    </motion.div>
  );
}
